import formatXml from "xml-formatter";

export type Language = "json" | "xml" | "text";

export class StringUtils {
    /**
     * Detects and pretty-prints JSON or XML.
     * Returns formatted string and detected language.
     */
    static formatData(data: string): { formattedData: string; language: Language } {
        if (!data) return { formattedData: "", language: "text" };

        // Try JSON
        try {
            const parsed = JSON.parse(data);
            return { formattedData: JSON.stringify(parsed, null, 2), language: "json" };
        } catch {
            // Not JSON, continue
        }

        // Try XML
        if (data.trim().startsWith("<")) {
            try {
                const pretty = formatXml(data, { indentation: "  " });
                return { formattedData: pretty, language: "xml" };
            } catch {
                // Not valid XML
            }
        }

        // Fallback: plain text
        return { formattedData: data, language: "text" };
    }
}